// import '../components/MyCard.css'

export default function Mycard(props){
    return(
        <div className="card">
            <img loading="lazy" src={props.img} className="card-img"/>
            <div className="context">
                <text className="card-text">{props.head}</text>
                <p className="card-description">{props.description}</p>
            </div>
        </div>
    )
}